import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

export const downloadCenterAppName = "@@dlc-2.0/"

const loadProfileObjs = makePieActionObjs("load", "profile")
const loadMoreForProfileObjs = makePieActionObjs("load", "moreProfile")
const loadTemplateObjs = makePieActionObjs("load", "template")
const loadInitialProfileObjs = makePieActionObjs("load", "initialProfileFromParams")
const loadOrganizationDesignObjs = makePieActionObjs("load", "design")
const autosaveTemplateObjs = makePieActionObjs("autosave", "template")
export const AUTOSAVE_TEMPLATE_PREFIX = "AUTOSAVE_TEMPLATE"

export const loadProfileTypes = prependAppName(downloadCenterAppName, loadProfileObjs.pieDict)
export const loadMoreForProfileTypes = prependAppName(downloadCenterAppName, loadMoreForProfileObjs.pieDict)
export const loadTemplateTypes = prependAppName(downloadCenterAppName, loadTemplateObjs.pieDict)
export const loadInitialProfileTypes = prependAppName(downloadCenterAppName, loadInitialProfileObjs.pieDict)
export const loadOrganizationDesignTypes = prependAppName(downloadCenterAppName, loadOrganizationDesignObjs.pieDict)
export const autosaveTemplateTypes = prependAppName(downloadCenterAppName, autosaveTemplateObjs.pieDict)

export const actionTypes = {
    UPDATE_CURRENT_PROFILE_FROM_URL: `${downloadCenterAppName}UPDATE_CURRENT_PROFILE_FROM_URL`,
    REGISTER_ELEMENT: `${downloadCenterAppName}REGISTER_ELEMENT`,
    CHANGE_PROFILE_QDT: `${downloadCenterAppName}CHANGE_PROFILE_QDT`,
    CHANGE_CURRENT_ORG_DESIGN: `${downloadCenterAppName}CHANGE_CURRENT_ORG_DESIGN`,
    SET_BULK_DOWNLOAD: `${downloadCenterAppName}SET_BULK_DOWNLOAD`,
    NEW_PAGE: `${downloadCenterAppName}NEW_PAGE`,
    RESET_FOOTER: `${downloadCenterAppName}RESET_FOOTER`,
    REMOVE_FOOTER: `${downloadCenterAppName}REMOVE_FOOTER`,
    REMOVE_PAGE: `${downloadCenterAppName}REMOVE_PAGE`,
    MOVE_ELEMENT_TO_NEW_PAGE: `${downloadCenterAppName}MOVE_ELEMENT_TO_NEW_PAGE`,
    REMOVE_ELEMENT_DETAILS_FIELD_IN: `${downloadCenterAppName}REMOVE_ELEMENT_DETAILS_FIELD_IN`,
    SET_ELEMENT_DETAILS_FIELD: `${downloadCenterAppName}SET_ELEMENT_DETAILS_FIELD`,
    SET_ELEMENT_DETAILS_FIELD_IN: `${downloadCenterAppName}SET_ELEMENT_DETAILS_FIELD_IN`,
    SET_ELEMENT_DETAILS_OBJ_DATA_FIELD_FOR_PROFILE: `${downloadCenterAppName}SET_ELEMENT_DETAILS_OBJ_DATA_FIELD_FOR_PROFILE`,
    UPDATE_LAST_UPDATED: `${downloadCenterAppName}UPDATE_LAST_UPDATED`,
    UPDATE_CURRENT_PAGE: `${downloadCenterAppName}UPDATE_CURRENT_PAGE`,
}

export default actionTypes
